import { http } from "../../../shared/api/http"

export type VacancyStatus = "active" | "inactive" | "draft"

export type VacancyItem = {
  id: string
  creator_id: string
  title: string
  salary_to: number | null
  salary_currency: string | null
  employment_type: string | null
  work_format: string | null
  views_count: number
  status: VacancyStatus
  is_active: boolean
  created_at: number
}

export type VacanciesListResponse = {
  items: VacancyItem[]
  total: number
}

export type VacanciesFilters = {
  limit?: number
  offset?: number
  status?: string
  work_format?: string
  employment_type?: string
}

export type Application = {
  applicant_id: string
  vacancy_id: string
  created_at: number
}

export type ApplicationsListResponse = {
  items: Application[]
  total: number
}

export const listVacanciesApi = (filters: VacanciesFilters = {}) =>
  http.get<VacanciesListResponse>("/api/admin/vacancies", { params: filters })

export const getVacancyApi = (vacancyId: string) =>
  http.get<VacancyItem>(`/api/admin/vacancies/${vacancyId}`)

export const setVacancyActiveApi = (vacancyId: string, isActive: boolean) =>
  http.patch<{ success: boolean }>(`/api/admin/vacancies/${vacancyId}/active`, { is_active: isActive })

export const deleteVacancyApi = (vacancyId: string) =>
  http.delete<{ success: boolean }>(`/api/admin/vacancies/${vacancyId}`)

export const listApplicationsApi = (vacancyId: string, limit = 20, offset = 0) =>
  http.get<ApplicationsListResponse>(`/api/admin/vacancies/${vacancyId}/applications`, {
    params: { limit, offset },
  })
